firebird.directive('presenterGreenroomFooter', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                helperService.getRedesignPathPrefix() + 'presenter-greenroom-footer.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
